import styled from "@emotion/styled"
import { RoomBranding } from "../../recoil/atoms/room/types"

export interface StylesProps {
  roomStyles?: RoomBranding
  isHomePage?: boolean
  isCamMuted?: boolean
  isMobile?: boolean
  сolorBorder?: string
  offHover?: boolean
  isSmallWindowHeight?: boolean
  wrapperWidth?: string
  isSmallView?: boolean
}

export const MobileControlButtonsContainer = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: center;
  width: 100%;
`

export const MobileWrapper = styled.div`
  width: 100%;
`

export const SettingsHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #dee2e6;
  background-color: #fff;
`

export const SettingsBody = styled.div<StylesProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  flex-grow: 1;
  color: #1a202c;
`

export const SettingsFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  background-color: #fff;
`

export const SettingsHeaderTitle = styled.h5<StylesProps>`
  font-size: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "1rem" : "1.25rem"};
  line-height: 1.5;
  font-weight: 500;
  display: flex;
  align-items: center;
`

export const SettingsBodyTitle = styled(SettingsHeaderTitle)<StylesProps>`
  margin-bottom: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.2rem" : "0.4rem"};
  color: ${({ roomStyles, isHomePage }) =>
    isHomePage
      ? roomStyles?.joinPagePanelTextColor ?? "#000000"
      : roomStyles.servicePanelElementPrimaryText &&
        roomStyles.servicePanelElementPrimaryText};
`
export const SettingsBodyText = styled.p<StylesProps>`
  font-size: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.7rem" : "1rem"};
  margin-bottom: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.5rem" : "1rem"};
  text-align: left;
  color: ${({ roomStyles, isHomePage }) =>
    isHomePage
      ? roomStyles?.joinPagePanelSubTextColor
      : roomStyles.servicePanelElementSecondaryText};
`
export const InputWrapper = styled.div<StylesProps>`
  display: flex;
  width: 100%;
  margin-bottom: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.5rem" : "1rem"};
`
export const Input = styled.input<StylesProps>`
  width: 100%;
  font-size: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.9rem" : "1rem"};
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: white;
  border: 2px solid #e2e8f0;
  border-left: none;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  padding: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0.3rem 0.75rem" : "0.375rem 0.75rem"};
`

export const Progress = styled.div<StylesProps>`
  height: 1rem;
  overflow: hidden;
  font-size: 0.75rem;
  background-color: ${({ roomStyles, isHomePage, сolorBorder }) =>
    !isHomePage
      ? roomStyles?.servicePanelElementBackground ?? "white"
      : "white"};
  border: ${({ roomStyles, isHomePage, сolorBorder }) =>
    !isHomePage
      ? roomStyles?.servicePanelElementBorder
        ? `2px solid ${сolorBorder ?? roomStyles?.servicePanelElementBorder}`
        : "2px solid #e2e8f0"
      : "2px solid #e2e8f0"};
  border-radius: 0.2rem;
  margin-bottom: ${({ isSmallWindowHeight }) =>
    isSmallWindowHeight ? "0px" : "10px"};
`
export const ProgressBar = styled.div`
  display: flex;
  transition: width 0.6s ease;
  height: 100%;

  /* border-bottom-right-radius: 0.25rem;
  border-top-right-radius: 0.25rem; */
  width: 30px;
`

export const VideoWrapper = styled.div<StylesProps>`
  width: ${({ wrapperWidth }) => wrapperWidth ?? "100%"};
  margin: ${({ isSmallView }) => isSmallView && "auto"};
`

export const Video = styled.div<StylesProps>`
  position: relative;
  padding-top: 56.25%;
  overflow: hidden;
  border-radius: 5px;
  border: ${({ isHomePage, roomStyles, сolorBorder }) =>
    isHomePage
      ? "2px solid #e2e8f0"
      : roomStyles?.servicePanelElementBorder
      ? `2px solid ${сolorBorder ?? roomStyles?.servicePanelElementBorder}`
      : "2px solid #e2e8f0"};
`

export const VideoContainer = styled.div<StylesProps>`
  background-color: ${({ roomStyles }) =>
    roomStyles?.alertBackgroundColor !== ""
      ? roomStyles?.alertBackgroundColor
      : "black"};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  > div {
    height: ${({ isCamMuted }) =>
      isCamMuted === true ? "unset !important" : "100% !important"};
    background-color: unset !important;
  }
  > div > video {
    height: 102% !important;
  }
`

export const Button = styled.button`
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
  transition: 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  &:hover {
    background-color: #0069d9;
    border-color: #0062cc;
  }
  &:focus {
    box-shadow: 0 0 0 0.2rem rgb(38 143 255 / 50%);
  }
`

export const ControlButton = styled.button<StylesProps>`
  border-radius: 50%;
  border: 1px solid
    ${({ roomStyles }) => roomStyles?.joinButtonBorderColor || "transparent"};
  background-color: ${({ roomStyles }) =>
    roomStyles?.joinButtonBackgroundColor || "#1AC541"};
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-right: ${({ isMobile }) => !isMobile && "15px"}; */
  color: ${({ roomStyles }) => roomStyles?.joinPageButtonTextColor || "#FFFFFF"};

  &:hover {
    color: ${({ roomStyles, offHover }) =>
      !offHover && (roomStyles?.joinPageButtonMouseoverTextColor || "#FFFFFF")};
    background-color: ${({ roomStyles, offHover }) =>
      !offHover &&
      (roomStyles?.joinButtonMouseoverBackgroundColor || "#24A840")};
  }

  &:active {
    color: ${({ roomStyles, offHover }) =>
      offHover && (roomStyles?.joinPageButtonMouseoverTextColor || "#FFFFFF")};
    background-color: ${({ roomStyles, offHover }) =>
      offHover && (roomStyles?.joinButtonMouseoverBackgroundColor || "#24A840")};
  }
`
